import { format } from 'date-fns'
import InfiniteScroll from 'react-infinite-scroll-component'
import CenteredLoadingAnimation from '../core/CenteredLoadingAnimation'
import ClickToCopy from '../core/ClickToCopy'
import { Flex } from '../core/Flex'
import Text from '../core/Text/Text'
import { prettyPrintWalletAddress } from '../core/Utils'
import { UserReport } from './components'
import { useUserDashboard } from './hooks'
import { SortableTableHeader } from './primitives'

const UsersDashboard = () => {
  const {
    isError,
    isLoading,
    data,
    hasNextPage,
    fetchNextPage,
    order,
    orderBy,
    handleOrderBy,
    totalUsers
  } = useUserDashboard()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '30px'
      }}
    >
      {isError && (
        <Text size="20" css={{ color: 'red' }}>
          Something went wrong!
        </Text>
      )}
      <>
        <Flex css={{ gap: '8px', alignItems: 'baseline' }}>
          <Text size="24" css={{ marginBottom: '$16' }}>
            Users
          </Text>
          <p style={{ marginBottom: '0', paddingBottom: '0' }}>(Profile Count: {totalUsers})</p>
        </Flex>
        <UserReport />
        <div className="fw-bold" style={{ display: 'flex', flexDirection: 'row' }}>
          <SortableTableHeader
            order={order}
            orderByValue={orderBy}
            orderByKey="displayName"
            title="Name"
            onClick={() => handleOrderBy('displayName')}
          />
          <div style={{ flex: '3' }}>Email</div>
          <div style={{ flex: '2' }}>Wallet (click to copy)</div>
          <SortableTableHeader
            order={order}
            orderByValue={orderBy}
            orderByKey="createdAt"
            title="Created at"
            onClick={() => handleOrderBy('createdAt')}
          />
        </div>
        {isLoading ? (
          <CenteredLoadingAnimation />
        ) : (
          <InfiniteScroll
            loader={<CenteredLoadingAnimation />}
            dataLength={data?.pages.length * 50}
            next={fetchNextPage}
            hasMore={hasNextPage}
            style={{ overflow: 'visible' }}
          >
            {data.pages.map((page) =>
              page.data.map((user) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      borderTop: '1px solid black'
                    }}
                    key={user.walletAddress}
                  >
                    <div style={{ flex: '2' }}>{user.displayName}</div>
                    <div style={{ flex: '3' }}>{user.email}</div>
                    <div style={{ flex: '2' }}>
                      <ClickToCopy
                        copyContent={user.walletAddress}
                        className="underline-on-hover cursor-pointer"
                      >
                        {prettyPrintWalletAddress(user.walletAddress)}
                      </ClickToCopy>
                    </div>
                    <div style={{ flex: '2' }}>
                      {format(new Date(user.createdAt), 'MM/dd/yyy, hh:ss aaa')}
                    </div>
                  </div>
                )
              })
            )}
          </InfiniteScroll>
        )}
      </>
    </div>
  )
}

export default UsersDashboard
